import { TabType } from "@hooks/useTabs";
import Eligibility from "@sba/components/Eligibility/Eligibility";
import Nominations from "@sba/components/Nominations";

/**
 * Returns the corresponding static component to render based on the provided active tab identifier.
 *
 * This function is typically used to dynamically render different sections of the
 * Singapore Business Awards (SBA) How to Nominate page.
 *
 * @param page - The string identifier of the active tab (e.g., "nominations", "eligibility").
 * @returns The React component corresponding to the given page, or `undefined` if not matched.
 */
export const HowToNominateTabsFactory = (tab: TabType) => {
  switch (tab) {
    case "nominations":
      return Nominations;

    case "eligibility":
      return Eligibility;
  }
};
